import { EventBroker } from "../../../lib/utils/event-broker";

export const EVENTS = {
  LISTEN: 'LISTEN',
  SAVE_CROPPED_SELECTION: 'SAVE_CROPPED_SELECTION',
  SAVE_AS_THEME_IMAGE: 'SAVE_AS_THEME_IMAGE',
  
}

export const saveSelectionAsEventBroker = new EventBroker();
